import './Footer.css';

function Footer()
{
    return (
        <div className='footer'>
            <p>© Choise of a Nation      email: melnikvlad2222@gmail.com</p>
        </div>
    );
}

export default Footer;